import config from 'config';

let backend_url = config.public_backend_url;

export default backend_url;
